"use strict";

/******************************************************
 *    Directive pour afficher les informations d'un élève
 ********************************************************/

import dayjs from "dayjs";

angular.module("app").directive("subscriberSubscriptions", [
	"FitiSubscriptionService", "ExploitationService", "Utils", "$uibModal", "$route", "StopAreasService", "toastr", "OkinaLeafletService",
	function (FitiSubscriptionService, ExploitationService, Utils, $uibModal, $route, StopAreasService, toastr, OkinaLeafletService) {
	return {
		restrict: "E",
		templateUrl: "common/directives/subscriberSubscriptions/subscriberSubscriptions.html",
		replace: false,
		isolated: false,
		link: function (scope, elem, attrs) {

			var addModal, editModal, addODModal, addTripModal, acceptAllWishesModal, confirmGenerationSubscriptionsModal, wishModal, confirmDeleteTrips;
			scope.saveAlreadyClickStopPointStudentChange = false;
			scope.addWish = false;
			scope.radioModelSubscriptions = "abonnement";

			const TAG = "subscriberSubscriptions";

			const IMPORTANT_ACTION_FOR_PARENT = "IMPORTANT_ACTION_FOR_PARENT";
			const UPDATE_SUBSCRIPTION_ACTION_FOR_PARENT = "UPDATE_SUBSCRIPTION_ACTION_FOR_PARENT";
			const NOT_ALL_SUBSCRIPTIONS_FOR_ITINERARY = "NOT_ALL_SUBSCRIPTIONS_FOR_ITINERARY";
			const UPDATE_SUBSCRIPTIONS_ID = "UPDATE_SUBSCRIPTIONS_ID";
			const ADD_TRIPS_BY_CALCULATOR = "ADD_TRIPS_BY_CALCULATOR";
			const UPDATE_WARNING_VEHICLE_FILLING_FOR_SUBSCRIBER_SUBCRIPTIONS = "UPDATE_WARNING_VEHICLE_FILLING_FOR_SUBSCRIBER_SUBCRIPTIONS";
			const ALERT_SUBSCRIPTIONS = "ALERT_SUBSCRIPTIONS";
			const SHOULD_RELOAD_FARES = "SHOULD_RELOAD_FARES";

			const RECEIVE = "RECEPTION";
			const SEND = "ENVOI";

			var tripsIdToGenerateSubscriptions = [];
			var wishesIdToGenerateSubscriptions = [];

			// Si présence d'un calendrier scolaire, initialisation
			FitiSubscriptionService.getSchoolCalendarEnd()
				.then(function (date) {
					scope.data.schooldeadLine = dayjs(date).valueOf(); // convert to unix timestamp
				})
				.catch(()=>toastr.error("schoolCalendarEnd"));

			function emitNewSubscriptionsId() {
				scope.$broadcast(UPDATE_SUBSCRIPTIONS_ID, scope.data.subscriptionsId);
			}

			scope.$on(NOT_ALL_SUBSCRIPTIONS_FOR_ITINERARY, function (event, data) {
				if (data === "WISH") {
					scope.data.wishsAlert = true;
				} else {
					scope.data.tripsAlert = true;
				}
			});

			scope.$on(UPDATE_SUBSCRIPTION_ACTION_FOR_PARENT, function (event, data) {
				for (let i = 0; i < scope.data.subscriptions.length; i++) {
					let subscription = scope.data.subscriptions[i];
					if (subscription.id === data) {
						scope.openEditModal(subscription);
					}
				}
			});

			scope.$on(ALERT_SUBSCRIPTIONS, function (event, data) {
				scope.data.subscriptionsAlert = true;
			});

			scope.$on(ADD_TRIPS_BY_CALCULATOR, function (event, data) {
				addTripModal.close();
				refreshSubscription();
			});

			scope.$on(UPDATE_WARNING_VEHICLE_FILLING_FOR_SUBSCRIBER_SUBCRIPTIONS, function (event, data) {
				scope.data.subscriptionsAlert = true;
				scope.data.vehicleFillingAlert = true;
			});

			scope.$on(IMPORTANT_ACTION_FOR_PARENT, function (event, data) {
				refreshSubscription();
			});

			scope.openAddTrip = function (wishBool) {
				scope.addWish = wishBool;
				addTripModal = Utils.openModal($uibModal, "addTripModalTemplate.html", scope, "screen");
			};

			function generateSubscriptionsByAcceptWish(wishId) {
				if (wishId === null && wishesIdToGenerateSubscriptions.length) {
					wishId = wishesIdToGenerateSubscriptions[0];
				}
				if (wishId) {
					FitiSubscriptionService.acceptWish(wishId, scope.modal.generateSubscriptions)
						.then(() => {
							refreshSubscription();
							wishesIdToGenerateSubscriptions.shift();
							generateSubscriptionsByAcceptWish(null);
						})
						.catch(() =>  {
							toastr.error("Problème lors de l'acceptation du voeu", "Erreur");
						});
				}
			}

			scope.acceptWishs = function () {
				wishesIdToGenerateSubscriptions = [];
				for (var i = 0; i < scope.modal.wishesToAccept.length; i++) {
					wishesIdToGenerateSubscriptions.push(scope.modal.wishesToAccept[i].id);
				}
				generateSubscriptionsByAcceptWish(null);
				acceptAllWishesModal.close();
			};

			function generateSubscriptionsForOneItinerary(itineraryId) {
				if (itineraryId === null && tripsIdToGenerateSubscriptions.length) {
					itineraryId = tripsIdToGenerateSubscriptions[0];
				}
				if (itineraryId) {
					FitiSubscriptionService.generateSubscriptionsByTrip(itineraryId)
						.then(() => {
							refreshSubscription();
							tripsIdToGenerateSubscriptions.shift();
							generateSubscriptionsForOneItinerary(null);
						})
						.catch(() => {
							toastr.error("Problème lors de la génération des abonnements", "Erreur");
						});
				}
			}

			scope.generateSubscriptionsAllForItinerary = function () {
				tripsIdToGenerateSubscriptions = [];
				for (var i = 0; i < scope.modal.tripsToAccept.length; i++) {
					tripsIdToGenerateSubscriptions.push(scope.modal.tripsToAccept[i].id);
				}
				generateSubscriptionsForOneItinerary(null);
				confirmGenerationSubscriptionsModal.close();
			};

			scope.openAcceptAllWishsModal = function (address) {
				scope.modal = {
					generateSubscriptions: true,
					wishesToAccept: []
				};
				for (var i = 0; i < address.wishs.length; i++) {
					var wish = address.wishs[i];
					if (!wish.wishAccepted) {
						scope.modal.wishesToAccept.push(wish);
					}
				}
				acceptAllWishesModal = Utils.openModal($uibModal, "acceptWishsModalTemplate.html", scope);
			};


			scope.openGenerationSubscriptionsModal = function (address) {
				scope.modal = {
					tripsToAccept: []
				};
				for (var i = 0; i < address.trips.length; i++) {
					var trip = address.trips[i];
					if (!trip.selected) {
						scope.modal.tripsToAccept.push(trip);
					}
				}
				confirmGenerationSubscriptionsModal = Utils.openModal($uibModal, "acceptGenerationSubscriptionsAllModalTemplate.html", scope);
			};

			scope.notAcceptAllTrips = function (address) {
				for (var i = 0; i < address.trips.length; i++) {
					var trip = address.trips[i];
					if (!trip.selected) {
						return true;
					}
				}
				return false;
			};

			/**
			 * Détermine si l'abonné est dans le bon statut pour pouvoir générer les abonnements
			 * @returns {boolean}
			 */
			scope.subscriberInCorrectStatus = () => {
				const authorizedStatusToGenerateSubscriptions = [
					FitiSubscriptionService.REGISTRATION_STATUS.WAITING_FOR_ASSIGNMENT,
					FitiSubscriptionService.REGISTRATION_STATUS.PRE_ASSIGNED,
					FitiSubscriptionService.REGISTRATION_STATUS.FULLY_ASSIGNED,
				];

				return authorizedStatusToGenerateSubscriptions.includes(scope.data.subscriber.registration.registrationStatus);
			};

			function getAddressWithTrip(trip) {
				for (var i = 0; i < scope.data.addressTrips.length; i++) {
					var address = scope.data.addressTrips[i];
					if (address.address === trip.address) {
						return address;
					}
				}
				return undefined;
			}

			function createPresentationListAddressAndWishes() {
				scope.data.addressTrips = [];
				// Ajouter les parcours aux adresses
				for (let i = 0; i < scope.data.trips.length; i++) {
					let trip = scope.data.trips[i];
					let address = getAddressWithTrip(trip);
					if (address !== undefined) {
						address.trips.push(trip);
					} else {
						scope.data.addressTrips.push({
							address: trip.address,
							trips: [trip]
						});
					}
				}
			}

			function getTripsForSubscriber() {
				FitiSubscriptionService.getTripsBySubscriber(scope.data.subscriber.id)
					.then((response) => {
						const data = response.data;
						scope.data.trips = [];
						scope.data.wishs = [];
						scope.data.wishsAlert = false;
						scope.data.tripsAlert = false;
						for (let i = 0; i < data.length; i++) {
							let trip = data[i];
							if (trip.type === "WISH") {
								scope.data.wishs.push(trip);
							} else {
								scope.data.trips.push(trip);
							}
						}
						createPresentationListAddressAndWishes();

						// Envoi un event pour que le controller recharge les tarifs
						scope.$emit(SHOULD_RELOAD_FARES);
					})
					.catch(function (data) {
						Utils.makeErrorMessage(data, "Problème lors de la récupération des itinéraires de l'abonné.");
					});
			}

			/**
			 * Stocker la liste des identifiants d'ODs de retour sélectionnés pour pouvoir l'ajouter au post lors de la validation de la page.
			 */
			scope.addOdsSubscriber = function () {
				var odsIdList = [];
				var selectedOds = scope.data.originDestinations.filter(function (od) {
					return od.selected;
				});
				selectedOds.map(function (od) {
					odsIdList.push(od.id);
				});

				FitiSubscriptionService.addSubscriptionOd(scope.data.subscriber.id, odsIdList)
					.then(() => {
						refreshSubscription();
						toastr.success("Abonnement(s) ajoutée(s)", "");
						addODModal.close();
					})
					.catch(() => {
						toastr.error("Problème lors de l'ajout d'abonnements", "Erreur");
					});

			};


			/**
			 * Ouvrir la popup pour ajout d'un abonnement.
			 */
			scope.openAddSubscriptionModal = function () {
				scope.data.addMode = true;
				scope.data.editMode = false;
				scope.razFilters();
				addModal = Utils.openModal($uibModal, "editModalTemplate.html", scope, "lg");
				scope.data.subscription = {
					subscriptionDate: new Date(),
					deadLine: new Date(new Date().setYear(new Date().getFullYear() + 1))
				};

				// Si présence d'un calendrier scolaire, initialisation
				FitiSubscriptionService.getSchoolCalendarEnd().then((date) => {
					scope.data.subscription.deadLine = new Date(date);
				});
			};

			scope.data.subscription = {
				subscriptionDate: new Date(),
				deadLine: new Date(new Date().setYear(new Date().getFullYear() + 1))
			};

			scope.razFilters = function () {
				scope.data.currentNetwork = scope.data.currentLine = scope.data.currentRoute = scope.data.currentCourse = undefined;
			};


			scope.editOrAddSubscription = function (subscription) {
				// Si sélection même départ / arrivé
				if (subscription.stopAreaDeparture != null && subscription.stopAreaArrival != null) {
					if (subscription.stopAreaDeparture.id === subscription.stopAreaArrival.id) {
						toastr.error("Impossible d'avoir le même point de départ et d'arrivé", "Action impossible");
						return;
					}
				}

				// Vérification date
				if (new Date(subscription.subscriptionDate) > new Date(subscription.deadLine)) {
					toastr.error("Problème dans les dates", "Action impossible");
					return;
				}

				// Conversion de la date suite à l'utilisation du Date Picker
				subscription.subscriptionDate = new Date(subscription.subscriptionDate).toLocaleDateString();
				subscription.deadLine = new Date(subscription.deadLine).toLocaleDateString();

				if (scope.data.currentCourse) {
					subscription.type = "VEHICLE_JOURNEY";
					subscription.courseId = scope.data.currentCourse;
				} else if (scope.data.currentLine) {
					subscription.type = "LINE";
					subscription.lineId = scope.data.currentLine;
				} else if (scope.data.currentNetwork) {
					subscription.type = "PT_NETWORK";
					subscription.networkId = scope.data.currentNetwork;
				}

				subscription.subscriber = scope.data.subscriber;

				if (scope.data.addMode) {
					FitiSubscriptionService.addSubscription(subscription)
						.then(() => {
							toastr.success("Abonnement enregistré", "");
							addModal.close();
							refreshSubscription();
							scope.data.addMode = false;
						})
						.catch((response) => {
							const error = response.error;
							scope.getSubscriber(scope.data.subscriber.id);
							toastr.error(Utils.makeErrorMessage(error, "Problème lors de l'ajout de l'abonnement"), "Erreur");
							// Reset dates to their original state.
							subscription.subscriptionDate = Utils.stringToDate(subscription.subscriptionDate, "dd/mm/yyyy", "/");
							subscription.deadLine = Utils.stringToDate(subscription.deadLine, "dd/mm/yyyy", "/");
						});
				} else if (scope.data.editMode) {
					FitiSubscriptionService.editSubscription(subscription)
						.then(() => {
							toastr.success("Abonnement modifié", "");
							editModal.close();
							refreshSubscription();
							scope.data.editMode = false;
						})
						.catch(() => {
							scope.getSubscriber(scope.data.subscriber.id);
							toastr.error("Problème lors de la modification de l'abonnement", "Erreur");
						});
				}
			};

			function getIdWithTypeSubscription(subscription){
				if(subscription.type.code === "PT_NETWORK"){
					return subscription.ptNetwork;
				}
				if(subscription.type.code === "LINE"){
					return subscription.line.id;
				}
				if(subscription.type.code === "VEHICLE_JOURNEY"){
					return subscription.vehicleJourney.id;
				}
			}

			function getSubscriptionsForSubscriber() {
				FitiSubscriptionService.getSubscriptionsForSubscriber(scope.data.subscriber.id).then((response) => {
					scope.data.subscriptions = response.data;
					scope.data.subscriptionsId = [];
					for (let i = 0; i < scope.data.subscriptions.length; i++) {
						const subscription = scope.data.subscriptions[i];
						if (subscription.active && subscription.deadLine===scope.data.schooldeadLine) {
							scope.data.subscriptionsId.push({
								type : subscription.type.code,
								id : getIdWithTypeSubscription(subscription),
								deadLine: subscription.deadLine
							});
						}
					}
					// Communiquer aux directives que le subscriptionsId à changé
					emitNewSubscriptionsId();
				});
			}

			function getWishesForSubscriber() {
				FitiSubscriptionService.getWishesBySubscriber(scope.data.subscriber.id)
					.then((response) => {
						scope.data.subscriber.stopPointsWishes = response.data;
					})
					.catch((error) => {
					    toastr.error(Utils.makeErrorMessage(error.data, ""));
					});
			}
			function refreshSubscription() {
				scope.data.subscriptionsAlert = false;
				scope.data.vehicleFillingAlert = false;
				getSubscriptionsForSubscriber();
				getTripsForSubscriber();
				getWishesForSubscriber();
			}

			refreshSubscription();

			// Gestion Date Start Picker
			scope.openDateStart = function ($event) {
				$event.preventDefault();
				$event.stopPropagation();
				scope.datadatestart.dateOpened = true;
			};

			scope.datadatestart = {
				dateFormat: "DD/MM/YYYY",
				date: scope.data.subscription.subscriptionDate,
				format: "dd/MM/yyyy",
				dateOptions: {
					startingDay: 1
				},
				counterTypesSelected: {},
				state: {
					editing: false,
					isOneGroupSelected: false,
					areSeveralGroupsSelected: false
				},
				selected: []
			};

			// Gestion Date Fin Picker
			scope.openDateEnd = function ($event) {
				$event.preventDefault();
				$event.stopPropagation();
				scope.datadateend.dateOpened = true;
			};

			scope.datadateend = {
				dateFormat: "DD/MM/YYYY",
				date: scope.data.subscription.deadLine,
				format: "dd/MM/yyyy",
				dateOptions: {
					startingDay: 1
				},
				counterTypesSelected: {},
				state: {
					editing: false,
					isOneGroupSelected: false,
					areSeveralGroupsSelected: false
				},
				selected: []
			};

			scope.getMinDate = function () {
				if (scope.datadateend.minDate > scope.data.subscription.subscriptionDate) {
					return scope.datadateend.minDate;
				} else {
					return scope.data.subscription.subscriptionDate;
				}
			};

			/**
			 * Démarrer le mode édition
			 */
			scope.editModeStart = function () {
				scope.data.editMode = true;
			};


			/**
			 * Quitter mode modification sans sauvegarder
			 */
			scope.exitModification = function () {
				scope.data.editMode = false;
				FitiSubscriptionService.getSubscriber($route.current.params.subscriberId).then((response) => {
					scope.data.subscriber = response.data;
				});
			};


			function findStopAreasToInstitution() {
				if (scope.data.subscriber.institutionId === null) {
					scope.data.listStopPointProximityInstitution = [];
				} else {
					FitiSubscriptionService.getStopAreasToInstitution(scope.data.subscriber.institutionId)
						.then((response) => {
							scope.data.listStopPointProximityInstitution = response.data;
						})
						.catch(() => {
							toastr.error("Problème lors de la récupération des points d'arrêts", "Erreur");
						});
				}
			}


			/**
			 * Trouver les arrêts qui correspond à la recherche
			 * @param search
			 */
			scope.findStopPoints = function (search) {
				if (!scope.data.currentCourse && search.length) {
					if (search.length >= 1) {
						StopAreasService.findCommercialStopAreaByNamePattern(search)
							.then((data) => {
								scope.data.listStopPointProximityHome = data;
							});
					}
				}
			};

			scope.stopPointStudentChange = function () {
				if (scope.saveAlreadyClickStopPointStudentChange) {
					var prov = scope.data.subscription.stopAreaDeparture;
					scope.data.subscription.stopAreaDeparture = scope.data.subscription.stopAreaArrival;
					scope.data.subscription.stopAreaArrival = prov;
				}
				scope.saveAlreadyClickStopPointStudentChange = true;
			};


			// MAJ propositions qd sélection VJ
			scope.$watch("data.currentCourse", function () {
				if (scope.data.currentCourse) {
					StopAreasService.findCommercialStopAreaVj(scope.data.currentCourse)
						.then((data) => {
							scope.data.listStopPointProximityHome = data;
						});
				}
			});

			/**
			 * Récupère l'historique et ouvre la popup permettant des les visualiser
			 */
			scope.openHistoricSubscription = () => {
				FitiSubscriptionService.getHistoricizedSubscriptions(scope.data.subscriber.id)
					.then((response) => {
						const data = response.data;
						if (data.length === 0) {
							toastr.info("Aucun historique d'abonnement pour cet abonné.");
						} else {
							scope.data.historicSubscriptions = data;
							Utils.openModal($uibModal, "subscriptionHistoric.html", scope, "lg");
						}
					})
					.catch((error) => {
						toastr.error(Utils.makeErrorMessage(error.data, "Erreur lors de la récupération de l'historique des abonnements."));
					});
			};


			/**
			 * Supprimer un trajet
			 */
			scope.deleteTrips = function (addressList) {
				FitiSubscriptionService.deleteTrips(addressList
						.map(address => address.trips)
						.flat()
						.map(trip => trip.id))
					.then(() => {
						toastr.success("Le trajet est supprimé", "");
						confirmDeleteTrips.close();
						reportImportantAction();
					})
					.catch(() => {
						toastr.error("Problème lors de la suppression du trajet", "Erreur");
					});
			};

			scope.openDeleteTripsModal = function (addressList) {
				scope.listAddressToDelete = addressList;
				confirmDeleteTrips = Utils.openModal($uibModal, "deleteTripsModalTemplate.html", scope);
			};

			function reportImportantAction() {
				scope.$emit(IMPORTANT_ACTION_FOR_PARENT);
			}

			/**
			 * Ouvre la popup d'édition d'un abonnement.
			 * @param subscription
			 */
			scope.openEditModal = function (subscription) {
				scope.razFilters();

				scope.data.subscription = angular.copy(subscription);

				if (subscription.ptNetwork) {
					scope.data.currentNetwork = subscription.ptNetwork;
					scope.data.subscription.infoTitle = "Réseau " + subscription.networkName;
				}

				if (subscription.line) {
					scope.data.currentLine = subscription.line.id;
					scope.data.subscription.infoTitle = "Ligne " + subscription.line.name;
				}

				if (subscription.route) {
					scope.data.currentRoute = subscription.route.id;
				}

				if (subscription.vehicleJourney) {
					scope.data.currentCourse = subscription.vehicleJourney.id;
					scope.data.subscription.infoTitle = "Course " + subscription.vehicleJourney.publishedJourneyName;
				}

				scope.data.editMode = true;
				scope.data.addMode = false;
				editModal = Utils.openModal($uibModal, "editModalTemplate.html", scope, "lg");
			};

			findStopAreasToInstitution();

			scope.generateTrips = () => {
				FitiSubscriptionService.generateTrips(scope.data.subscriber.id)
					.then(() => {
						// On reload l'abonné
						if (scope.$parent != null
							&& angular.isFunction(scope.$parent.getSubscriber)) {
							scope.$parent.getSubscriber(scope.data.subscriber.id);
						}
						getTripsForSubscriber();
					})
					.catch((error) => {
					    toastr.error(Utils.makeErrorMessage(error.data, ""));
					});
			};

			scope.areTripsGenerable = () => {
				const registrationStatusAllowed = [
					"PRE_ASSIGNED",
					"WAITING_FOR_EXAMINATION",
					"WAITING_FOR_ASSIGNMENT",
				];

				return registrationStatusAllowed.includes(scope.data.subscriber.registration.registrationStatus)
					&& scope.data.trips.length === 0;
			}
		}
	};
}])
;
